var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleLeftStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 737,
    height: 561,
    viewBox: "0 0 737 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616.629 61.5042C618.487 61.4144 619.921 59.835 619.831 57.9763C619.742 56.1176 618.162 54.6837 616.304 54.7734C614.445 54.8632 613.011 56.4427 613.101 58.3013C613.191 60.16 614.77 61.5939 616.629 61.5042Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640.153 7.60434C641.304 7.54875 642.192 6.57058 642.136 5.41929C642.081 4.26799 641.103 3.37993 639.951 3.43552C638.8 3.49112 637.912 4.46931 637.968 5.6206C638.023 6.77121 639.001 7.65994 640.153 7.60434Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M643.833 83.8168C644.984 83.7612 645.872 82.783 645.817 81.6317C645.761 80.4804 644.783 79.5924 643.632 79.648C642.48 79.7036 641.592 80.6817 641.648 81.833C641.704 82.9836 642.682 83.8724 643.833 83.8168Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M713.988 59.9111C714.044 61.0623 713.155 62.0406 712.004 62.0962C710.853 62.1518 709.875 61.2636 709.819 60.1124C709.764 58.9613 710.652 57.983 711.803 57.9274C712.954 57.8718 713.932 58.7599 713.988 59.9111Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M693.844 17.9708C697.719 18.4033 700.879 21.2732 701.683 25.0883C702.116 21.2128 704.986 18.0524 708.801 17.2485C704.925 16.8161 701.765 13.9462 700.961 10.1311C700.529 14.0066 697.659 17.167 693.844 17.9708Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2102 300.169C18.0688 300.08 19.5028 298.5 19.413 296.642C19.3233 294.783 17.7438 293.349 15.8851 293.439C14.0265 293.528 12.5925 295.108 12.6823 296.967C12.772 298.825 14.3515 300.259 16.2102 300.169Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7341 246.27C40.8854 246.214 41.7734 245.236 41.7178 244.084C41.6622 242.933 40.6841 242.045 39.5328 242.101C38.3815 242.156 37.4934 243.135 37.549 244.286C37.6046 245.436 38.5828 246.325 39.7341 246.27Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4144 322.482C44.5657 322.426 45.4537 321.448 45.3981 320.297C45.3425 319.146 44.3644 318.258 43.2131 318.313C42.0618 318.369 41.1737 319.347 41.2293 320.498C41.2849 321.649 42.2631 322.538 43.4144 322.482Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 298.576C113.625 299.728 112.737 300.706 111.586 300.761C110.434 300.817 109.456 299.929 109.4 298.778C109.345 297.627 110.233 296.648 111.384 296.593C112.535 296.537 113.514 297.425 113.569 298.576Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.425 256.636C97.3005 257.069 100.461 259.938 101.265 263.753C101.697 259.878 104.567 256.718 108.382 255.914C104.507 255.481 101.346 252.611 100.542 248.796C100.11 252.672 97.2401 255.832 93.425 256.636Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M248.629 526.504C250.487 526.415 251.921 524.835 251.831 522.976C251.742 521.118 250.162 519.684 248.303 519.774C246.445 519.863 245.011 521.443 245.101 523.301C245.19 525.16 246.77 526.594 248.629 526.504Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.153 472.604C273.304 472.549 274.192 471.571 274.136 470.419C274.081 469.268 273.103 468.38 271.951 468.436C270.8 468.491 269.912 469.469 269.967 470.621C270.023 471.771 271.001 472.66 272.153 472.604Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M275.833 548.817C276.984 548.761 277.872 547.783 277.817 546.632C277.761 545.48 276.783 544.592 275.632 544.648C274.48 544.704 273.592 545.682 273.648 546.833C273.703 547.984 274.682 548.872 275.833 548.817Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M345.988 524.911C346.043 526.062 345.155 527.041 344.004 527.096C342.853 527.152 341.875 526.264 341.819 525.113C341.763 523.961 342.651 522.983 343.803 522.927C344.954 522.872 345.932 523.76 345.988 524.911Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.843 482.971C329.719 483.403 332.879 486.273 333.683 490.088C334.116 486.213 336.985 483.052 340.801 482.249C336.925 481.816 333.765 478.946 332.961 475.131C332.528 479.007 329.658 482.167 325.843 482.971Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleLeftStars);
export default __webpack_public_path__ + "static/media/middle-left-stars.f18a3720eaa90e663d0e68735a04478f.svg";
export { ForwardRef as ReactComponent };